import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { graphql } from '@apollo/client/react/hoc';
import CityListQuery from 'queries/CityListQuery.gql';
import Spinner from 'components/Spinner';
import styles from './style.module.scss';

const CityNeighborhoodListPage = (props) => {
  return (
    <div>
      {props.data.loading && <Spinner />}
      <ul className={styles.cities}>
        {props.data &&
          props.data.cities &&
          props.data.cities.map((c) => (
            <li key={c.id}>
              <Link to={`/buildings${c.slug}`} className={styles.city}>
                {c.name}, {c.state}
              </Link>
              {c.neighborhoods.length > 0 && (
                <ul className={styles.neighborhoods}>
                  {c.neighborhoods.map((n) => (
                    <li key={n.slug}>
                      <Link
                        to={`/buildings${n.slug.replace('/office-space', '')}`}
                      >
                        {n.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
              <hr />
            </li>
          ))}
      </ul>
    </div>
  );
};

CityNeighborhoodListPage.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    cities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        state: PropTypes.string,
        name: PropTypes.string,
        neighborhoods: PropTypes.arrayOf(
          PropTypes.shape({
            slug: PropTypes.string,
            name: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
};

export default graphql(CityListQuery)(CityNeighborhoodListPage);
